import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useDatasetSessionStorageContext } from '../../../hooks/context/useDatasetSessionStorageContext';
import { useDatasetContext } from '../../../hooks/context/useDatasetContext';
import useRoutes from '../../../hooks/useRoutes';
import { getSubsetAndItemParams } from '../../../utils/getSubsetAndItemParams';
import { isFromPageReload } from '../../../utils/isFromPageReload';
import { GlobalLocationStateType } from '../../../types/types';

export const useDatasetUrlItemReloadGuard = () => {
  const { pathname } = useLocation<GlobalLocationStateType>();
  const routes = useRoutes();
  const history = useHistory();
  const { setDatasetSessionStorageState, getDatasetSessionStorageState } =
    useDatasetSessionStorageContext();
  const { datasetId, dataset } = useDatasetContext();
  const { subsetId, itemId } = getSubsetAndItemParams(pathname);

  useEffect(() => {
    const handler = () => {
      if (!datasetId || !itemId) return;

      // flag reload from itemurl
      if (
        (subsetId && pathname === routes.subset(datasetId, itemId, subsetId)) ||
        pathname === routes.subsetDetail(datasetId, itemId)
      ) {
        setDatasetSessionStorageState({ reloadFromItem: true });
      }
    };

    window.addEventListener('beforeunload', handler);

    return () => {
      window.removeEventListener('beforeunload', handler);
    };
  }, [datasetId, subsetId, itemId]);

  useEffect(() => {
    if (!datasetId) return;

    // Handle only non filter first scenarios.
    // Filter first scenario must be handled in useDebounceEffect in DatasetList
    if (isFromPageReload() && !dataset?.filterFirst) {
      const state = getDatasetSessionStorageState();
      setDatasetSessionStorageState({ reloadFromItem: undefined });

      if (state.reloadFromItem === true) {
        history.push(routes.datasetList(datasetId));
      }
    }
  }, [datasetId]);
};
